import { render, staticRenderFns } from "./ManagePushNotificationPage.vue?vue&type=template&id=7d5664fb&"
import script from "./ManagePushNotificationPage.vue?vue&type=script&lang=js&"
export * from "./ManagePushNotificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports